<template>
<label class="categoryToggle" >
  <button @click="toggleActive" :class="[ 'categoryToggle__toggle', activeClass,]  "
          :style="{}"  v-model="visibleCats" :data-toggle-category="category.name">
      <div class="categoryToggle__switchBg" tabindex="-1" >
          <span class="categoryToggle__switchOn" :style="{opacity:isVisible ? 1 : 0}" tabindex="-1" >ON</span>
          <span class="categoryToggle__switchOff" :style="{opacity:isVisible ? 0 : 1}" tabindex="-1" >OFF</span>
      </div>
      <div class="categoryToggle__switch"
            :style="{}" tabindex="-1" ></div>

  </button>
    <span class="categoryToggle__toggleText">{{category.name}}</span>

</label>

</template>
<script>


export default {
  name: 'CategoryToggle',
  components : {
  },
  data () {
    return {

    }
  },
  methods : {
    toggleActive() {
      if (this.isVisible) {
          this.$store.dispatch('removeVisibleCat', {id : this.category.id})
      }  else {
          this.$store.dispatch('addVisibleCat', {id :this.category.id })
      }
    }
  },
  props: ["category"],
  computed : {
      activeClass() {
        return this.isVisible ? 'categoryToggle__toggle--active' : '';
      },
      visibleCats () {return this.$store.getters.rtVisCats },

      isVisible (){
          return this.visibleCats ? this.visibleCats.includes(this.category.id) : false
      }

  },
}


</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/CategoryToggleVuex.vue